export default "__VITE_ASSET__247e713f__"